import PropTypes from 'prop-types';

export const currentUserPropTypes = {
  currentUser: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      accountId: PropTypes.string.isRequired,
      features: PropTypes.array,
      toggles: PropTypes.array,
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      created_at: PropTypes.string.isRequired
    }),
    PropTypes.shape({})
  ]).isRequired,
};

export default {
  ...currentUserPropTypes,
  currentAccount: PropTypes.oneOfType([
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      subdomain: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      time_zone: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      plan: PropTypes.string.isRequired
    }),
    PropTypes.shape({})
  ]).isRequired
};
